import { notifyError, notify } from '../../components/notify.tsx';
import api from '../api.js';

export const getForecastsByAnoMes = async (cookies, ano, mes, unidade_id = null) => {
  try {
    let url = `/forecast_by_ano/${ano}/${mes}`;

    if (unidade_id) {
      url += `?unidade_id=${unidade_id}`;
    }

    const response = await api.get(url, {
      headers: {
        authorization: `Bearer ${cookies.usuario.accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao buscar forecasts por ano e mês:', error);
    notifyError('Erro ao buscar dados de forecast');
    throw error;
  }
};

export const getForecastById = async (cookies, id) => {
  try {
    const response = await api.get(`/forecast_by_id/${id}`, {
      headers: {
        authorization: `Bearer ${cookies.usuario.accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao buscar forecast por ID:', error);
    notifyError('Erro ao buscar dados de forecast');
    throw error;
  }
};

export const createForecast = async (cookies, forecastData) => {
  try {
    const response = await api.post('/create_forecast', forecastData, {
      headers: {
        authorization: `Bearer ${cookies.usuario.accessToken}`,
      },
    });

    notify('Forecast salvo com sucesso!');
    return response.data;
  } catch (error) {
    console.error('Erro ao criar forecast:', error);
    notifyError('Erro ao salvar forecast');
    throw error;
  }
};
